import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';

import { GlobalErrorHandler } from './core/handlers/global-error-handler';
import { apiRequestInterceptor } from './core/interceptors/api-request-interceptor';
import { errorInterceptor } from './core/interceptors/error-interceptor';
import { ApplicationInsightsService } from './core/services/application-insights.service';
import { TenantService } from './core/services/tenant-service';
import { CustomDateAdapter } from './shared/adapter/custom-date.adapter';
import { MATERIAL_DATE_FORMATS } from './shared/utilities/date.utils';
import { routes } from './app.routes';
import { CommonService } from './core/services/common.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideAppInitializer(async () => {
      inject(ApplicationInsightsService);
      const tenantService = inject(TenantService);
      const commonService = inject(CommonService);
      await tenantService.initialize();
      return commonService.getFeatureFlags();
    
    }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MATERIAL_DATE_FORMATS },
    provideHttpClient(withInterceptors([apiRequestInterceptor, errorInterceptor])),
    { provide: LOCALE_ID, useValue: 'en-AU' },
    { provide: MAT_DATE_LOCALE, useValue: 'en-AU' },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
        subscriptSizing: 'dynamic',
      } as MatFormFieldDefaultOptions,
    },
  ],
};
